(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-carousel';
  var sectionState = new Map();
  var SCROLL_SETTLE_MS = 180;
  var MOBILE_QUERY = '(max-width: 749px)';
  var MOBILE_GUTTER = 16;

  function initSection(section) {
    var track = section.querySelector('[data-ugc-track]');
    var dotsWrap = section.querySelector('[data-ugc-dots]');
    if (!track || !dotsWrap) return;

    var originalSlides = Array.prototype.slice.call(
      track.querySelectorAll('.oddit-section-ugc-carousel__slide')
    );
    if (originalSlides.length === 0) return;

    var N = originalSlides.length;
    var autoplaySpeed = parseFloat(section.getAttribute('data-autoplay-speed')) || 5;
    var autoplayMs = Math.max(1000, autoplaySpeed * 1000);

    dotsWrap.innerHTML = '';
    var dots = [];
    for (var di = 0; di < N; di++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oddit-section-ugc-carousel__dot';
      btn.setAttribute('data-ugc-dot', String(di));
      btn.setAttribute('aria-label', 'Go to slide ' + (di + 1));
      var inner = document.createElement('span');
      inner.setAttribute('aria-hidden', 'true');
      inner.innerHTML = '&zwnj;';
      btn.appendChild(inner);
      dotsWrap.appendChild(btn);
      dots.push(btn);
    }

    var mobileMQ = window.matchMedia(MOBILE_QUERY);
    var isMobile = mobileMQ.matches;
    var allSlides = [];

    var state = {
      position: 0,
      isHovered: false,
      isVisible: true,
      autoplayTimer: null,
      scrollEndTimer: null
    };

    function rebuildSlides() {
      Array.prototype.forEach.call(
        track.querySelectorAll('[data-ugc-clone]'),
        function (c) { c.remove(); }
      );

      var fragBefore = document.createDocumentFragment();
      var fragAfter = document.createDocumentFragment();
      originalSlides.forEach(function (s) {
        var before = s.cloneNode(true);
        before.setAttribute('data-ugc-clone', 'before');
        before.setAttribute('aria-hidden', 'true');
        before.classList.remove('oddit-reveal');
        fragBefore.appendChild(before);

        var after = s.cloneNode(true);
        after.setAttribute('data-ugc-clone', 'after');
        after.setAttribute('aria-hidden', 'true');
        after.classList.remove('oddit-reveal');
        fragAfter.appendChild(after);
      });
      track.insertBefore(fragBefore, track.firstChild);
      track.appendChild(fragAfter);

      allSlides = Array.prototype.slice.call(
        track.querySelectorAll('.oddit-section-ugc-carousel__slide')
      );
      state.position = N;
    }

    function updateSidePadding() {
      if (isMobile) {
        track.style.paddingLeft = MOBILE_GUTTER + 'px';
        track.style.paddingRight = MOBILE_GUTTER + 'px';
        track.style.scrollPaddingLeft = MOBILE_GUTTER + 'px';
        track.style.scrollPaddingRight = MOBILE_GUTTER + 'px';
        return;
      }
      track.style.scrollPaddingLeft = '0px';
      track.style.scrollPaddingRight = '0px';
      var first = allSlides[0];
      if (!first) return;
      var slideW = first.getBoundingClientRect().width;
      var trackW = track.clientWidth;
      var pad = Math.max(0, (trackW - slideW) / 2);
      track.style.paddingLeft = pad + 'px';
      track.style.paddingRight = pad + 'px';
    }

    function targetScrollLeftFor(pos) {
      var slide = allSlides[pos];
      if (!slide) return 0;
      if (isMobile) {
        return slide.offsetLeft - MOBILE_GUTTER;
      }
      return slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    }

    function scrollToPosition(pos, smooth) {
      var target = targetScrollLeftFor(pos);
      track.scrollTo({ left: Math.round(target), behavior: smooth ? 'smooth' : 'auto' });
    }

    function scrollToPositionInstant(pos) {
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = Math.round(targetScrollLeftFor(pos));
      track.style.scrollBehavior = prev;
    }

    function realIndexFor(pos) {
      return ((pos - N) % N + N) % N;
    }

    function setDotForPosition(pos) {
      var realIdx = realIndexFor(pos);
      for (var i = 0; i < dots.length; i++) {
        if (i === realIdx) {
          dots[i].classList.add('oddit-section-ugc-carousel__dot--active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('oddit-section-ugc-carousel__dot--active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function setActiveSlideMarker(pos) {
      for (var i = 0; i < allSlides.length; i++) {
        allSlides[i].classList.toggle(
          'oddit-section-ugc-carousel__slide--active',
          i === pos
        );
      }
    }

    function findPositionFromScroll() {
      if (isMobile) {
        var refX = track.scrollLeft + MOBILE_GUTTER;
        var bestStart = 0;
        var bestStartDist = Infinity;
        for (var j = 0; j < allSlides.length; j++) {
          var sLeft = allSlides[j].offsetLeft;
          var ds = Math.abs(sLeft - refX);
          if (ds < bestStartDist) {
            bestStartDist = ds;
            bestStart = j;
          }
        }
        return bestStart;
      }
      var centerX = track.scrollLeft + track.clientWidth / 2;
      var bestIdx = state.position;
      var bestDist = Infinity;
      for (var i = 0; i < allSlides.length; i++) {
        var s = allSlides[i];
        var sCenter = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(sCenter - centerX);
        if (d < bestDist) {
          bestDist = d;
          bestIdx = i;
        }
      }
      return bestIdx;
    }

    function normalizeIfInCloneZone() {
      if (state.position < N) {
        state.position += N;
        scrollToPositionInstant(state.position);
        setActiveSlideMarker(state.position);
      } else if (state.position >= 2 * N) {
        state.position -= N;
        scrollToPositionInstant(state.position);
        setActiveSlideMarker(state.position);
      }
    }

    function onScroll() {
      var pos = findPositionFromScroll();
      setDotForPosition(pos);
      if (state.scrollEndTimer) clearTimeout(state.scrollEndTimer);
      state.scrollEndTimer = setTimeout(function () {
        state.scrollEndTimer = null;
        state.position = findPositionFromScroll();
        setDotForPosition(state.position);
        setActiveSlideMarker(state.position);
        normalizeIfInCloneZone();
      }, SCROLL_SETTLE_MS);
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    // Mouse drag-to-scroll. Touch scrolling is already native via overflow-x.
    var drag = {
      active: false,
      pointerId: null,
      startX: 0,
      startScrollLeft: 0,
      moved: false
    };
    var DRAG_MOVE_THRESHOLD = 4;

    function onPointerDown(e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      drag.active = true;
      drag.pointerId = e.pointerId;
      drag.startX = e.clientX;
      drag.startScrollLeft = track.scrollLeft;
      drag.moved = false;
    }

    function onPointerMove(e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      var dx = e.clientX - drag.startX;
      if (!drag.moved) {
        if (Math.abs(dx) < DRAG_MOVE_THRESHOLD) return;
        drag.moved = true;
        track.classList.add('oddit-section-ugc-carousel__track--dragging');
        // Disable scroll-snap mid-drag so mandatory snap doesn't fight the
        // pointer — restored on endDrag once we snap to the nearest slide.
        track.style.scrollSnapType = 'none';
        try { track.setPointerCapture(drag.pointerId); } catch (err) {}
        stopAutoplay();
      }
      track.scrollLeft = drag.startScrollLeft - dx;
      if (e.cancelable) e.preventDefault();
    }

    function endDrag(e) {
      if (!drag.active || (e && e.pointerId !== drag.pointerId)) return;
      var wasMoved = drag.moved;
      drag.active = false;
      drag.pointerId = null;
      try { track.releasePointerCapture(e && e.pointerId); } catch (err) {}
      if (!wasMoved) return;
      track.classList.remove('oddit-section-ugc-carousel__track--dragging');
      // Snap to the nearest slide after release, then re-enable CSS snap.
      var nearest = findPositionFromScroll();
      state.position = nearest;
      scrollToPosition(nearest, true);
      setDotForPosition(nearest);
      setActiveSlideMarker(nearest);
      setTimeout(function () {
        track.style.scrollSnapType = '';
      }, 400);
      restartAutoplay();
    }

    function onDragClick(e) {
      if (drag.moved) {
        e.preventDefault();
        e.stopPropagation();
        drag.moved = false;
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', onDragClick, true);

    // Forward predominantly-vertical wheel events to the page.
    function onWheel(e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        window.scrollBy({ top: e.deltaY, behavior: 'auto' });
      }
    }
    track.addEventListener('wheel', onWheel, { passive: false });

    function goToPosition(pos, smooth) {
      state.position = pos;
      scrollToPosition(pos, smooth !== false);
      setDotForPosition(pos);
      setActiveSlideMarker(pos);
    }

    function goToRealIndex(realIdx) {
      var candidates = [realIdx, realIdx + N, realIdx + 2 * N];
      var best = candidates[0];
      var bestD = Math.abs(candidates[0] - state.position);
      for (var i = 1; i < candidates.length; i++) {
        var d = Math.abs(candidates[i] - state.position);
        if (d < bestD) {
          bestD = d;
          best = candidates[i];
        }
      }
      goToPosition(best, true);
    }

    function next() {
      goToPosition(state.position + 1, true);
    }

    function startAutoplay() {
      if (state.autoplayTimer) return;
      if (state.isHovered || !state.isVisible) return;
      state.autoplayTimer = setInterval(next, autoplayMs);
    }

    function stopAutoplay() {
      if (state.autoplayTimer) {
        clearInterval(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    section.addEventListener('mouseenter', function () {
      state.isHovered = true;
      stopAutoplay();
    });
    section.addEventListener('mouseleave', function () {
      state.isHovered = false;
      startAutoplay();
    });

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          state.isVisible = entries[0].isIntersecting;
          if (state.isVisible) startAutoplay();
          else stopAutoplay();
        },
        { threshold: 0 }
      );
      io.observe(section);
    }

    dotsWrap.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-ugc-dot]');
      if (!dot) return;
      var idx = parseInt(dot.getAttribute('data-ugc-dot'), 10);
      if (isNaN(idx)) return;
      goToRealIndex(idx);
      restartAutoplay();
    });

    track.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      var slide = e.target.closest('.oddit-section-ugc-carousel__slide');
      if (!slide) return;
      var idx = allSlides.indexOf(slide);
      if (idx === -1 || idx === state.position) return;
      goToPosition(idx, true);
      restartAutoplay();
    });

    // Hover-to-play for UGC videos. Direct mouseenter/leave per-slide is
    // simpler than delegation and survives slide cloning since we re-bind
    // each time `allSlides` is rebuilt.
    function bindSlideVideoHover(slide) {
      var video = slide.querySelector('[data-ugc-video]');
      if (!video || slide._ugcVideoBound) return;
      slide._ugcVideoBound = true;
      // Force muted at the property level — the attribute alone isn't always
      // honored by autoplay policy after cloneNode.
      video.muted = true;
      video.setAttribute('muted', '');

      slide.addEventListener('mouseenter', function () {
        try { video.currentTime = 0; } catch (err) {}
        video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {});
        }
      });
      slide.addEventListener('mouseleave', function () {
        video.pause();
        try { video.currentTime = 0; } catch (err) {}
      });
    }

    function bindAllVideoHovers() {
      for (var i = 0; i < allSlides.length; i++) {
        bindSlideVideoHover(allSlides[i]);
      }
    }

    function applyMode() {
      rebuildSlides();
      updateSidePadding();
      scrollToPositionInstant(state.position);
      setDotForPosition(state.position);
      setActiveSlideMarker(state.position);
      bindAllVideoHovers();
    }

    var onMobileChange = function (e) {
      isMobile = e.matches;
      applyMode();
      restartAutoplay();
    };
    if (mobileMQ.addEventListener) {
      mobileMQ.addEventListener('change', onMobileChange);
    } else if (mobileMQ.addListener) {
      mobileMQ.addListener(onMobileChange);
    }

    var resizeObserver = null;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        updateSidePadding();
        scrollToPositionInstant(state.position);
      });
      resizeObserver.observe(track);
    }
    var onWindowResize = function () {
      updateSidePadding();
      scrollToPositionInstant(state.position);
    };
    window.addEventListener('resize', onWindowResize);

    requestAnimationFrame(function () {
      applyMode();
      startAutoplay();
    });

    sectionState.set(section.id || section, {
      track: track,
      onScroll: onScroll,
      onWindowResize: onWindowResize,
      mobileMQ: mobileMQ,
      onMobileChange: onMobileChange,
      io: io,
      resizeObserver: resizeObserver,
      stop: stopAutoplay,
      onWheel: onWheel
    });
  }

  function destroySection(section) {
    var key = section.id || section;
    var saved = sectionState.get(key);
    if (!saved) return;
    if (saved.track && saved.onScroll) {
      saved.track.removeEventListener('scroll', saved.onScroll);
    }
    if (saved.onWindowResize) {
      window.removeEventListener('resize', saved.onWindowResize);
    }
    if (saved.mobileMQ && saved.onMobileChange) {
      if (saved.mobileMQ.removeEventListener) {
        saved.mobileMQ.removeEventListener('change', saved.onMobileChange);
      } else if (saved.mobileMQ.removeListener) {
        saved.mobileMQ.removeListener(saved.onMobileChange);
      }
    }
    if (saved.io) saved.io.disconnect();
    if (saved.resizeObserver) saved.resizeObserver.disconnect();
    if (saved.stop) saved.stop();
    if (saved.track && saved.onWheel) saved.track.removeEventListener('wheel', saved.onWheel);
    sectionState.delete(key);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
